import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import { KeyboardCapslock } from "@mui/icons-material";
import React from "react";
import { Tooltip } from "@mui/material";

import { compareVersions } from "./version-utils";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: {
      marginRight: "2px",
    },
    icon: {
      color: "green",
    },
  })
);

export const NewestFirmware = (props: {
  defType?: number;
  defVersion: string | number;
  currType?: number;
  currVersion: string | number;
}) => {
  const classes = useStyles();
  const { defType, defVersion, currType, currVersion } = props;

  const isNewest = defType !== undefined 
    ? defType < currType! || (defType === currType && compareVersions(defVersion, currVersion) < 0)
    : compareVersions(defVersion, currVersion) < 0;

  return (
    <>
      {isNewest && (
        <Tooltip title={`Новейшая прошивка. Дефолтная: ${defVersion}`}>
          <KeyboardCapslock className={classes.icon} />
        </Tooltip>
      )}
    </>
  );
};
